module.exports = __webpack_public_path__ + "71e5988987a206b4cb3fa449bebb4f2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/vertex_pharmaceuticals_2023_chart.png
// module id = 1757
// module chunks = 0